import { createConfiguration } from "./configuration";
import { Router } from "./router";

var Application =
/** @class */
function () {
  function Application(configurationOptions) {
    if (configurationOptions === void 0) {
      configurationOptions = {};
    }

    this.configuration = createConfiguration(configurationOptions);
    this.router = new Router(this);
  }

  Application.start = function (configurationOptions) {
    var application = new Application(configurationOptions);
    application.start();
    return application;
  };

  Application.prototype.start = function () {
    this.router.start();
  };

  Application.prototype.stop = function () {
    this.router.stop();
  };

  Application.prototype.register = function (identifier, controllerConstructor) {
    this.router.register(identifier, controllerConstructor);
  };

  Application.prototype.unregister = function (identifier) {
    this.router.unregister(identifier);
  };

  Application.prototype.getControllerForElementAndIdentifier = function (element, identifier) {
    var context = this.router.getContextForElementAndIdentifier(element, identifier);
    return context ? context.controller : null;
  };

  return Application;
}();

export { Application };